/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Mimzad ERP API
 * Core and Shared Event Backbone API for Mimzad ERP
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `material_revision` - Material Revision
* `bom_revision` - BOM Revision
 */
export type SourceTypeEnum = typeof SourceTypeEnum[keyof typeof SourceTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SourceTypeEnum = {
  material_revision: 'material_revision',
  bom_revision: 'bom_revision',
} as const;
